import { PaymentDetailsHeader } from "./payment-details-header";
import { PaymentDetailsProps } from "./types";
import { BigNumber } from "bignumber.js";
import { formatPrice } from "./lib/format-price";
import { FeeBreakdown } from "./fee-breakdown";
import { SummaryLine } from "./summary-line";
import { calculateFees } from "./lib/calculate-fees";

export const InvestmentAmountPaymentDetails = ({
	title,
	investmentId,
	updatedAt,
	createdAt,
	currency = "USD",
	feeView = "simplified",
	investmentAmount = "0",
	className,
	gstPercentage = "0",
	fixedFeeDetails = [],
}: PaymentDetailsProps) => {
	const investmentAmountBN = BigNumber(investmentAmount);
	const gstPercentageBN = BigNumber(gstPercentage);
	
	const result = calculateFees(
		investmentAmountBN,
		fixedFeeDetails,
		gstPercentageBN.toNumber(),
	);
	const totalFee = result.fee.toNumber();
	const gstFee = result.gstFee.toNumber();
	const totalFeeWithGst = result.totalFeeWithGst.toNumber();

	return (
		<div className={`rounded-lg border p-4 pt-0 w-[600px] ${className}`}>
			<div className="flex flex-col gap-4">
				<PaymentDetailsHeader
					title={title}
					updatedAt={updatedAt}
					investmentId={investmentId}
					createdAt={createdAt}
				/>
				<SummaryLine
					field="Investment amount"
					value={`${formatPrice(investmentAmountBN.toNumber())} ${currency.toUpperCase()}`}
				/>
				<FeeBreakdown
					totalFees={BigNumber(totalFee)}
					gstFee={BigNumber(gstFee)}
					feeView={feeView}
					gstPercentage={gstPercentageBN.toNumber()}
					currency={currency}
					fixedFeeDetails={fixedFeeDetails}
				/>
				<hr />
				<div className="flex justify-between">
					<div className="text-sm font-bold text-gray-600">Total</div>
					<div className="text-sm font-bold text-[#383838]">{`${formatPrice(
						totalFeeWithGst,
					)} ${currency.toUpperCase()}`}</div>
				</div>
			</div>
		</div>
	);
};
